export default __webpack_public_path__ + "static/media/traced.8b293046.svg";